
const digest = '891136712c987004f53619c2208007a20c7d10dedb1f8d113db6651b3b4ed2e6';
const classes = {"wrapper":"_wrapper_1lomg_1","leftSide":"_leftSide_1lomg_7","count":"_count_1lomg_12","rightSide":"_rightSide_1lomg_20","infoText":"_infoText_1lomg_27","viewToggle":"_viewToggle_1lomg_31","toggleGrid":"_toggleGrid_1lomg_38","active":"_active_1lomg_46","toggleList":"_toggleList_1lomg_49"};
const css = `._wrapper_1lomg_1 {
  padding: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1lomg_1 ._leftSide_1lomg_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
._wrapper_1lomg_1 ._leftSide_1lomg_7 ._count_1lomg_12 {
  color: #1d65d8;
  font-size: 14px;
  font-weight: 600;
}
._wrapper_1lomg_1 ._leftSide_1lomg_7 ._count_1lomg_12 span {
  font-weight: 400;
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: flex-end;
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 ._infoText_1lomg_27 {
  color: #929292;
  font-size: 14px;
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 ._viewToggle_1lomg_31 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  cursor: pointer;
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 ._viewToggle_1lomg_31 ._toggleGrid_1lomg_38 {
  background-image: url("/dist/icons/v2/grid-solid-inactive.svg");
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  width: 17px;
  height: 17px;
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 ._viewToggle_1lomg_31 ._toggleGrid_1lomg_38._active_1lomg_46 {
  background-image: url("/dist/icons/v2/grid-solid-active.svg");
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 ._viewToggle_1lomg_31 ._toggleList_1lomg_49 {
  background-image: url("/dist/icons/v2/list-solid-inactive.svg");
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  width: 17px;
  height: 17px;
}
._wrapper_1lomg_1 ._rightSide_1lomg_20 ._viewToggle_1lomg_31 ._toggleList_1lomg_49._active_1lomg_46 {
  background-image: url("/dist/icons/v2/list-solid-active.svg");
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  